export default __webpack_public_path__ + "static/media/welcome-page.af74d4ca.png";